// extracted by mini-css-extract-plugin
module.exports = {"textArea":"EditableParagraph_textArea__MVHiN","editable":"EditableParagraph_editable__7tqQX","paragraph":"EditableParagraph_paragraph__3_SM3"};